export const adventures = [
  {
    title: 'プライベート美術館ツアー',
    description: '通常非公開のコレクション、美術館閉館後の特別鑑賞。学芸員の解説とともに、アートの深淵へ誘います。'
  },
  {
    title: '美食探訪',
    description: '予約困難な名店、築地の仲卸との朝食、酒蔵訪問。食通のコンシェルジュが厳選した、東京の美食を巡る旅。'
  },
  {
    title: '文化体験',
    description: '茶道、華道、能楽。日本文化の真髄に触れる特別なひととき。人間国宝の技を間近で見る、贅沢な体験もご用意しております。'
  }
];